<template>
  <div>
    <b-modal
      ref="customer-view-modal"
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Customer View"
      @ok="createUser"
      @cancel="hideModal"
    >
      <!-- card-header -->
      <div v-if="customer">
        <b-row>
          <b-col cols="4">
            <div>
              <h3 class="tx-26 tx-normal tx-rubik tx-spacing--2">
                {{ customer.name }}
              </h3>
              <span class="tx-medium"
                >(
                {{
                  customer.reference_number ? customer.reference_number : ""
                }})</span
              >

              <div class="">
                <div class="badge badge-success">
                  {{ customer.is_active ? "Active" : "Inactive" }}
                </div>
                <div>
                  {{
                    customer.contact[0].phone ? customer.contact[0].phone : ""
                  }}
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="8">
            <b-row>
              <b-col cols="3">
                <div class="card text-white bg-info mb-3">
                  <div class="card-header text-center">
                    Total Amount<br />{{ total | amount }}
                  </div>
                </div>
              </b-col>
              <b-col cols="3">
                <div class="card text-white bg-success mb-3">
                  <div class="card-header text-center">
                    Paid Amount<br />{{ total_paid | amount }}
                  </div>
                </div>
              </b-col>
              <b-col cols="3">
                <div class="card text-white bg-danger mb-3">
                  <div class="card-header text-center">
                    Due Amount<br />{{ due_amount | amount }}
                  </div>
                </div>
              </b-col>
              <b-col cols="3">
                <div class="card text-white bg-dark mb-3">
                  <div class="card-header text-center">
                    Discount Amount<br />{{ total_discount | amount }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="6">
            <p>Par 11</p>
          </b-col>
          <b-col cols="6">
            <p>Par 11</p>
          </b-col>
        </b-row> -->
        <hr />
        <!-------Customer Related Factors-------->
        <div>
          <b-row>
            <b-col cols="3">
              <v-select
                v-model="selectedShop"
                class="select_"
                :get-option-label="(option) => option.sortform"
                :options="shops"
                placeholder="Select Shop"
                @input="onChangeShop"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="selectedSaleType"
                class="select_"
                :get-option-label="(option) => option.name"
                :options="saleTypeSearchList"
                placeholder="Select Sale Type"
                @input="onChangeSaleType"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="selectedPaymentType"
                class="select_"
                :get-option-label="(option) => option.name"
                :options="paymentStatusSearchList"
                placeholder="Payment Status"
                @input="onChangePaymentStatus"
              />
            </b-col>
            <b-col cols="3" class="float-end">
              <input
                v-model="query"
                type="string"
                class="form-control"
                placeholder="search"
                style="margin-bottom: 10px; border-radius: 10px"
                @input="fetchCustomerSales"
              />
            </b-col>
          </b-row>

          <!--customer sales list -->
          <div>
            <b-row v-if="loading" class="d-flex justify-content-center">
              <b-spinner
                style="width: 3rem; height: 3rem"
                variant="primary"
                label="Spinning"
              />
            </b-row>
            <b-row v-if="!loading && sales.length > 0">
              <b-col cols="12" class="text-center">
                <table class="table table-hover table-striped">
                  <tbody>
                    <tr>
                      <th class="text-center">Date</th>
                      <th class="text-center">Shop Name</th>
                      <th class="text-center">Total</th>
                      <th class="text-center">Discount</th>
                      <th class="text-center">Paid</th>
                      <th class="text-center">Type</th>
                      <th class="text-center">Biller</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Action</th>
                    </tr>
                    <tr
                      v-for="(item, index) in sales"
                      :key="index"
                      style="border-bottom: 1px solid #c1c1c1"
                    >
                      <td class="text-center">
                        {{ item.date | formatDate }}
                      </td>
                      <td class="text-center">
                        {{ item.shop.sortform }}
                      </td>
                      <td class="text-right">
                        {{ item.grand_total | amount }}
                      </td>
                      <td class="text-right">
                        {{ item.discount_amount | amount }}
                      </td>
                      <td class="text-right">
                        {{ item.paid_amount | amount }}
                      </td>
                      <td class="text-center">
                        <p
                          style="
                            color: #ffffff !important;
                            line-height: 1.5;
                            border-radius: 4px !important;
                            font-size: 10px;
                            height: 16px;
                            align-items: center;
                          "
                          :style="
                            item.sale_type == 'Cash'
                              ? 'background-color: #4CAF50 !important; '
                              : 'background-color: #ff0000 !important'
                          "
                        >
                          {{ item.sale_type }}
                        </p>
                      </td>
                      <td class="text-center">
                        {{ item.biller.first_name }}
                      </td>
                      <td class="text-center">
                        <p
                          style="
                            color: #ffffff !important;
                            line-height: 1.5;
                            border-radius: 4px !important;
                            font-size: 10px;
                            height: 16px;
                            align-items: center;
                          "
                          :style="
                            item.status == 'Completed'
                              ? 'background-color: #4CAF50 !important; '
                              : 'background-color: #555555 !important'
                          "
                        >
                          {{ item.status }}
                        </p>
                      </td>
                      <td class="text-center">
                        <i
                          v-b-toggle.sale-return-sidebar
                          class="fa fa-print"
                          aria-hidden="true"
                          style="color: red"
                          @click="onSelect(item.id)"
                          data-toggle="tooltip"
                          data-placement="top"
                          data-custom-class="tooltip-primary"
                          title="Previus Bill"
                        />
                        <i
                          v-b-toggle.customer-payment-sidebar
                          class="fa fa-money ml-2"
                          aria-hidden="true"
                          style="color: blue"
                          @click="onSelect(item.id)"
                          data-toggle="tooltip"
                          data-placement="top"
                          data-custom-class="tooltip-primary"
                          title="Payment"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row v-else-if="!loading" class="pl-3 pr-3 text-center">
              <b-col>
                <b-alert show variant="warning"> No Sales Found </b-alert>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <!-- card-body -->
      <!-- card -->
    </b-modal>

    <CustomerForm ref="customerForm" :selected-customer="data" for="edit" />
    <Sidebar id="sale-return-sidebar" :width="500" title="Sales Details" right>
      <PrintBill />
    </Sidebar>
    <Payment id="customer-payment-sidebar" />
  </div>
</template>
<script>
// Components
import CustomerForm from "@/components/Customer/CustomerForm";
// Models
import { mapState } from "vuex";
import Sidebar from "@/components/base/Sidebar";
import Payment from "./payment.vue";
import { CustomerModel, CustomerDecorator } from "@/models/CustomerModel";
import { ContactModel, ContactDecorator } from "@/models/CustomerModel";
import { AddressModel, AddressDecorator } from "@/models/AddressModel";
import PrintBill from "../saleReturn/PrintBill.vue";
import moment from "moment";

export default {
  name: "CreateCustomer",

  components: {
    CustomerForm,
    Sidebar,
    PrintBill,
    Payment,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    selectedPaymentType: null,
    selectedSaleType: null,
    selectedShop: null,
    total_discount: 0.0,
    total: 0.0,
    total_paid: 0.0,
    due_amount: 0.0,
    customer_type_id: "",
    saleType: "",
    saleTypeSearchList: [
      { name: "cash" },
      { name: "card" },
      { name: "cheque" },
      { name: "other" },
    ],
    paymentStatusSearchList: [
      { name: "Pending" },
      { name: "Completed" },
      { name: "Cancelled" },
    ],
    shop: "",
    query: "",
    paymentStatus: "",
    loading: false,
    // dialog: false
    tab: 0,
    customer: { ...CustomerModel },
    customerTypes: [
      { id: 1, name: "Type 01" },
      { id: 2, name: "Type 02" },
      { id: 3, name: "Type 03" },
    ],
    customerGroups: [
      { id: 1, name: "Type 01" },
      { id: 2, name: "Type 02" },
      { id: 3, name: "Type 03" },
    ],
  }),
  computed: {
    ...mapState("customer", ["sales"]),
    ...mapState("shops", ["shops"]),
  },
  mounted() {
    // this.initialize();
  },
  methods: {
    fetchCustomerSales() {
      this.loading = true;
      this.$store
        .dispatch("customer/fetchCustomerSales", {
          id: this.data.id,
          query: this.query,
          saleType: this.saleType,
          paymentStatus: this.paymentStatus,
          shop: this.shop,
        })
        .then((res) => {
          this.loading = false;
          this.getTotal();
        })
        .catch(async (err) => {
          this.loading = false;
          this.getTotal();
        });
    },
    getTotal() {
      this.total = 0.0;
      this.total_discount = 0.0;
      this.total_paid = 0.0;
      this.due_amount = 0.0;
      this.sales.map((items) => {
        this.total_discount =
          this.total_discount + parseFloat(items.discount_amount);
        this.total_paid = this.total_paid + parseFloat(items.paid_amount);
        this.total = this.total + parseFloat(items.grand_total);
      });
      this.due_amount = this.total - this.total_paid;
    },
    onChangeShop(value) {
      if (value) {
        this.shop = value.id;
      } else {
        this.shop = "";
      }
      this.fetchCustomerSales();
    },
    onChangeSaleType(value) {
      if (value) {
        this.saleType = value.name;
      } else {
        this.saleType = "";
      }
      this.fetchCustomerSales();
    },
    onChangePaymentStatus(value) {
      if (value) {
        this.paymentStatus = value.name;
      } else {
        this.paymentStatus = "";
      }
      this.fetchCustomerSales();
    },
    onSelect(id) {
      this.fetchReturnInfo(id);
      this.hideModal();
      this.$refs["return-sidebar"].show();
    },
    fetchReturnInfo(id) {
      this.$store.dispatch("sales/fetchSalesInfo", { id });
    },
    openCustomerEditModal() {
      this.hideModal();
      this.customerFormFor = "edit";
      this.$refs.customerForm.showModal();
    },
    fetchUser() {
      const customerId = this.data.id;
      this.$store.dispatch("customer/fetchUser", customerId).then((res) => {
        this.customer = res.data;
      });
    },
    showModal() {
      this.total = 0.0;
      this.total_discount = 0.0;
      this.total_paid = 0.0;
      this.due_amount = 0.0;
      this.fetchUser();
      this.fetchCustomerSales();
      setTimeout(() => {
        this.$refs["customer-view-modal"].show();
      }, 400);
    },

    hideModal() {
      this.$refs["customer-view-modal"].hide();
    },
    createUser() {},
  },
};
</script>
<style scoped>
.total_card {
  color: blue !important;
}
</style>
